module.exports = __webpack_public_path__ + "90a524bbf1272771886fbd1f801e2d75.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/god-splitter-video-poster.jpg
// module id = 351
// module chunks = 0